import React from 'react';
import Icon, { IconProps } from './Icon';

const AccessoriesIcon: React.FC<IconProps> = ({ size = 28, color = '#343B91', ...props }) => {
  return (
    <Icon size={size} color={color} viewBox="0 0 28 28" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.6808 2.00004C10.6808 1.63185 10.9793 1.33337 11.3475 1.33337H16.1475C16.5157 1.33337 16.8141 1.63185 16.8141 2.00004V13.8243L19.613 18.7635L21.9497 17.5727C22.2777 17.4055 22.6792 17.536 22.8463 17.864C23.0135 18.192 22.8831 18.5935 22.5551 18.7607L20.271 19.9247L22.3275 23.5537C22.3843 23.6539 22.4141 23.7672 22.4141 23.8824V26C22.4141 26.3682 22.1157 26.6667 21.7475 26.6667H5.74748C5.37929 26.6667 5.08081 26.3682 5.08081 26V23.8824C5.08081 23.7636 5.11255 23.647 5.17273 23.5446L7.25449 20.0027L10.7645 13.6766C10.9432 13.3546 11.349 13.2385 11.6709 13.4171C11.9929 13.5957 12.1091 14.0015 11.9304 14.3235L9.27051 19.1174L16.7755 16.4605L15.5675 14.3287C15.5107 14.2285 15.4808 14.1152 15.4808 14V2.66671H12.0141V11.6667C12.0141 12.0349 11.7157 12.3334 11.3475 12.3334C10.9793 12.3334 10.6808 12.0349 10.6808 11.6667V2.00004ZM17.443 17.6386L8.28501 20.8807L6.41414 24.0638V25.3334H21.0808V24.0582L17.443 17.6386Z"
        fill={color}
      />
    </Icon>
  );
};

export default AccessoriesIcon;

